"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";

export interface HomeSectionCardV2Props {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  surface?: "default" | "interactive" | "highlighted";
}

export function HomeSectionCardV2({
  title,
  description,
  actions,
  children,
  surface = "default"
}: HomeSectionCardV2Props) {
  return (
    <section
      className={cn(
        homeCardVariants({ variant: "section" }),
        "p-4 md:p-5",
        surface === "interactive" &&
          "overflow-hidden transition-all duration-300 hover:shadow-lg",
        surface === "highlighted" &&
          "overflow-hidden bg-gradient-to-br from-blue-50 to-blue-100 transition-all duration-300 hover:shadow-lg dark:from-blue-950 dark:to-blue-900"
      )}
    >
      {(title || description || actions) && (
        <header className="mb-4 flex items-start justify-between gap-3">
          <div>
            {title && (
              <h3 className="text-sm font-semibold text-slate-900 dark:text-zinc-100">{title}</h3>
            )}
            {description && (
              <p className="mt-1 text-xs text-slate-500 dark:text-zinc-400">{description}</p>
            )}
          </div>
          {actions}
        </header>
      )}
      <div>{children}</div>
    </section>
  );
}
